import request from '@/router/axios';
export const add = (row) => {
return request({
url: '/api/produce/cust-info/insert',
method: 'post',
data: row
})
}
export const update = (row) => {
return request({
url: '/api/produce/cust-info/update',
method: 'post',
data: row
})
}
export const getDetail = (id) => {
return request({
url: '/api/produce/cust-info/select/id',
method: 'get',
params: {
id
}
})
}
export const getList = (params) => {
return request({
url: '/api/produce/cust-info/select/page',
method: 'get',
params
})
}
export const remove = (ids) => {
return request({
url: '/api/produce/cust-info/delete/ids',
method: 'get',
params: {
ids
}
})
}

